import { Drawer } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Drawer)`
  position: relative;
`;

export const Actions = styled.div`
  float: right;
  margin-top: 20px;
`;

export const TokenDisplay = styled.div`
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  margin: 16px;
  word-break: break-all;
  font-family: monospace;
  font-size: 12px;
  max-height: 150px;
  overflow-y: auto;
`;

export const TokenActions = styled.div`
  display: flex;
  gap: 10px;
  margin: 16px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px;
`;
